
// import React, { useEffect, useState } from "react";
// import { hasAnyPermission } from "../utils/permissions";
// import {
//   Box,
//   Container,
//   Typography,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   TablePagination,
//   CircularProgress,
//   Alert,
//   TextField,
//   Snackbar,
//   IconButton,
//   Tooltip,
//   InputAdornment,
//   Chip
// } from "@mui/material";
// import AdminSidebar from '../AdminSidebar';
// import Toolbar from '@mui/material/Toolbar';
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';
// import { fetchCandidates, createCandidate, updateCandidate, deleteCandidate, resetCandidatePassword, fetchRoles } from "../api";
// import { useAuth } from "../App";
// import Forbidden403 from "../components/common/Forbidden403";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import LockResetIcon from "@mui/icons-material/LockReset";

// import CloseIcon from "@mui/icons-material/Close";
// import { useNavigate, useSearchParams } from "react-router-dom";

// function ResetPasswordModal({ open, onClose, onSubmit, user, loading, error }) {
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [localError, setLocalError] = useState("");

//   useEffect(() => {
//     setPassword("");
//     setLocalError("");
//   }, [open, user]);

//   const handleSave = () => {
//     if (!password || password.length < 8) {
//       setLocalError("Password must be at least 8 characters");
//       return;
//     }
//     onSubmit(password);
//   };
//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
//       <DialogTitle>Reset Password for {user?.email}</DialogTitle>
//       <DialogContent sx={{ minWidth: 320 }}>
//         <TextField
//           label="New Password"
//           type={showPassword ? "text" : "password"}
//           value={password}
//           onChange={e => setPassword(e.target.value)}
//           fullWidth
//           autoFocus
//           margin="normal"
//           InputProps={{
//             endAdornment: (
//               <InputAdornment position="end">
//                 <IconButton
//                   aria-label="toggle password visibility"
//                   onClick={() => setShowPassword(s => !s)}
//                   edge="end"
//                   size="small"
//                 >
//                   {showPassword ? <VisibilityOff /> : <Visibility />}
//                 </IconButton>
//               </InputAdornment>
//             ),
//           }}
//           error={!!localError || !!error}
//           helperText={localError || error}
//           disabled={loading}
//         />
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} disabled={loading}>Cancel</Button>
//         <Button onClick={handleSave} variant="contained" disabled={loading || !password}>
//           Save
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// function CandidateDetailsModal({ open, onClose, user }) {
//   if (!user) return null;
//   let activeColor = user.is_active ? "success" : "default";
//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//         Candidate Details
//         <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
//       </DialogTitle>
//       <DialogContent>
//         <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
//           <Typography variant="h6">{user.full_name}</Typography>
//           <Typography component="span" variant="body2" color="text.secondary">({user.email})</Typography>
//           <Chip label={user.is_active ? "Active" : "Inactive"} color={activeColor} size="small" sx={{ ml: 1 }} />
//         </Box>
//         <Typography variant="body2"><b>Phone:</b> {user.phone || '-'}</Typography>
//         <Typography variant="body2"><b>Address:</b> {user.address || '-'}</Typography>
//       </DialogContent>
//     </Dialog>
//   );
// }

// function CandidateTable({ users, onEdit, onDelete, onDeactivate, onResetPassword, loading, search, setSearch, onRowClick }) {
//   return (
//     <Box>
//       <TextField
//         label="Search"
//         value={search}
//         onChange={e => setSearch(e.target.value)}
//         size="small"
//         sx={{ mb: 2, width: 300 }}
//         InputProps={{
//           endAdornment: (
//             <InputAdornment position="end">
//               <IconButton>
//                 <Visibility />
//               </IconButton>
//             </InputAdornment>
//           ),
//         }}
//       />
//       <Table size="small">
//         <TableHead>
//           <TableRow>
//             <TableCell>Name</TableCell>
//             <TableCell>Email</TableCell>
//             <TableCell>Status</TableCell>
//             <TableCell>Actions</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {users.map(user => (
//             <TableRow key={user.id} hover onClick={() => onRowClick(user)} style={{ cursor: 'pointer' }}>
//               <TableCell>{user.full_name}</TableCell>
//               <TableCell>{user.email}</TableCell>
//               <TableCell>
//                 <Chip label={user.is_active ? "Active" : "Inactive"} color={user.is_active ? "success" : "default"} size="small" />
//               </TableCell>
//               <TableCell>
//                 <Tooltip title="Edit"><IconButton onClick={e => { e.stopPropagation(); onEdit(user); }}><EditIcon fontSize="small" /></IconButton></Tooltip>
//                 {user.is_active ? (
//                   <Tooltip title="Deactivate"><IconButton onClick={e => { e.stopPropagation(); onDeactivate(user); }}><DeleteIcon fontSize="small" color="warning" /></IconButton></Tooltip>
//                 ) : (
//                   <Tooltip title="Delete Permanently"><IconButton onClick={e => { e.stopPropagation(); onDelete(user); }}><DeleteIcon fontSize="small" color="error" /></IconButton></Tooltip>
//                 )}
//                 <Tooltip title="Reset Password"><IconButton onClick={e => { e.stopPropagation(); onResetPassword(user); }}><LockResetIcon fontSize="small" /></IconButton></Tooltip>
//               </TableCell>
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </Box>
//   );
// }

// function CandidateModal({ open, onClose, user, roles, onSave, loading }) {
//   const [form, setForm] = useState(user || { 
//     email: '', 
//     full_name: '', 
//     is_active: true,
//     is_applicant: true, 
//     role_ids: [],
//     password: '',
//     confirm_password: ''
//   });
  
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
  
//   useEffect(() => { 
//     setForm(user || { 
//       email: '', 
//       full_name: '', 
//       is_active: true,
//       is_applicant: true, 
//       role_ids: [],
//       password: '',
//       confirm_password: ''
//     });
//     setErrors({});
//   }, [user, open]);
  
//   const handleChange = (field) => (e) => {
//     setForm({ ...form, [field]: e.target.value });
    
//     // Clear error when field is edited
//     if (errors[field]) {
//       setErrors({ ...errors, [field]: null });
//     }
//   };
  
//   const handleToggleActive = () => {
//     setForm({ ...form, is_active: !form.is_active });
//   };
  
//   const handleToggleApplicant = () => {
//     setForm({ ...form, is_applicant: !form.is_applicant });
//   };
  
//   const validateForm = () => {
//     const newErrors = {};
    
//     if (!form.email) {
//       newErrors.email = 'Email is required';
//     } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.email)) {
//       newErrors.email = 'Invalid email address';
//     }
    
//     if (!form.full_name) {
//       newErrors.full_name = 'Full name is required';
//     }
    
//     // Only validate password fields for new candidates
//     if (!user) {
//       if (!form.password) {
//         newErrors.password = 'Password is required';
//       } else if (form.password.length < 8) {
//         newErrors.password = 'Password must be at least 8 characters';
//       }
      
//       if (!form.confirm_password) {
//         newErrors.confirm_password = 'Confirm password is required';
//       } else if (form.password !== form.confirm_password) {
//         newErrors.confirm_password = 'Passwords do not match';
//       }
//     }
    
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };
  
//   const handleSave = () => {
//     if (!validateForm()) return;
    
//     // Create a copy of the form data without the confirm_password field
//     const formData = { ...form };
//     delete formData.confirm_password;
    
//     onSave(formData);
//   };
  
//   const toggleShowPassword = () => {
//     setShowPassword(!showPassword);
//   };
  
//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle>{user ? "Edit Candidate" : "Create Candidate"}</DialogTitle>
//       <DialogContent>
//         <Box component="form" noValidate sx={{ mt: 1 }}>
//           <TextField 
//             label="Full Name" 
//             value={form.full_name || ''} 
//             onChange={handleChange('full_name')} 
//             fullWidth 
//             margin="normal" 
//             required
//             disabled={!!user}
//             error={!!errors.full_name}
//             helperText={errors.full_name}
//             autoFocus
//           />
//           <TextField 
//             label="Email" 
//             value={form.email || ''} 
//             onChange={handleChange('email')} 
//             fullWidth 
//             margin="normal" 
//             disabled={!!user} 
//             required
//             error={!!errors.email}
//             helperText={errors.email}
//             type="email"
//           />
          
//           {!user && (
//             <>
//               <TextField
//                 label="Password"
//                 value={form.password || ''}
//                 onChange={handleChange('password')}
//                 fullWidth
//                 margin="normal"
//                 required
//                 type={showPassword ? 'text' : 'password'}
//                 error={!!errors.password}
//                 helperText={errors.password}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         aria-label="toggle password visibility"
//                         onClick={toggleShowPassword}
//                         edge="end"
//                       >
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//               <TextField
//                 label="Confirm Password"
//                 value={form.confirm_password || ''}
//                 onChange={handleChange('confirm_password')}
//                 fullWidth
//                 margin="normal"
//                 required
//                 type={showPassword ? 'text' : 'password'}
//                 error={!!errors.confirm_password}
//                 helperText={errors.confirm_password}
//               />
//             </>
//           )}
          
//           <Box sx={{ mt: 3, display: 'flex', alignItems: 'center' }}>
//             <Typography variant="body1" sx={{ mr: 2 }}>Status:</Typography>
//             <Chip 
//               label={form.is_active ? "Active" : "Inactive"} 
//               color={form.is_active ? "success" : "default"} 
//               onClick={handleToggleActive}
//               sx={{ cursor: 'pointer' }}
//             />
//           </Box>
//           <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
//             <Typography variant="body1" sx={{ mr: 2 }}>Applicant:</Typography>
//             <Chip 
//               label={form.is_applicant ? "Yes" : "No"} 
//               color={form.is_applicant ? "primary" : "default"} 
//               onClick={handleToggleApplicant}
//               sx={{ cursor: 'pointer' }}
//             />
//           </Box>
//         </Box>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} disabled={loading}>Cancel</Button>
//         <Button 
//           onClick={handleSave} 
//           variant="contained" 
//           disabled={loading || !form.email || !form.full_name || (!user && (!form.password || !form.confirm_password))}
//         >
//           {user ? 'Update' : 'Create'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }

// export default function Candidates() {
//   const { auth, fetchWithAuth } = useAuth();
//   const hasListPermission = hasAnyPermission(auth?.user, ["candidate.list", "user.list"]);
//   if (!hasListPermission) {
//     return (
//       <Box sx={{ display: 'flex', minHeight: '100vh', background: '#f7f7fa' }}>
//         <AdminSidebar selected="Candidates" />
//         <Box sx={{ flex: 1, p: 3, mt: 7, mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <Forbidden403 message="You are not authorized to perform this action. Please contact your system administrator." />
//         </Box>
//       </Box>
//     );
//   }

//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [detailsUser, setDetailsUser] = useState(null);
//   const [resetModalOpen, setResetModalOpen] = useState(false);
//   const [resetUser, setResetUser] = useState(null);
//   const [resetLoading, setResetLoading] = useState(false);
//   const [resetError, setResetError] = useState(null);
//   const [success, setSuccess] = useState("");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [roles, setRoles] = useState([]);
//   const [searchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const [shouldAutoOpenCandidateModal, setShouldAutoOpenCandidateModal] = useState(false);
//   useEffect(() => { loadData(); fetchRoles(fetchWithAuth).then(setRoles).catch(() => {}); }, []);
//   const loadData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const data = await fetchCandidates(fetchWithAuth);
//       setUsers(data);
//     } catch (e) {
//       setError(e.message || "Failed to load candidates");
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     const openParam = searchParams.get("open");
//     if (openParam === "create") {
//       setShouldAutoOpenCandidateModal(true);
//       navigate("/admin/candidates", { replace: true });
//     }
//   }, [searchParams, navigate]);
  
//   useEffect(() => {
//     if (shouldAutoOpenCandidateModal) {
//       handleCreate();
//       setShouldAutoOpenCandidateModal(false);
//     }
//   }, [shouldAutoOpenCandidateModal]);
//   const handleEdit = (user) => { setSelectedUser(user); setModalOpen(true); };
//   const handleCreate = () => { setSelectedUser(null); setModalOpen(true); };
//   const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
//   const [confirmDialogAction, setConfirmDialogAction] = useState(null);
//   const [userToAction, setUserToAction] = useState(null);
//   const [confirmDialogTitle, setConfirmDialogTitle] = useState("");
//   const [confirmDialogMessage, setConfirmDialogMessage] = useState("");

//   const openConfirmDialog = (title, message, action, user) => {
//     setConfirmDialogTitle(title);
//     setConfirmDialogMessage(message);
//     setConfirmDialogAction(action);
//     setUserToAction(user);
//     setConfirmDialogOpen(true);
//   };

//   const handleConfirmDialogClose = () => {
//     setConfirmDialogOpen(false);
//   };

//   const handleConfirmAction = async () => {
//     setConfirmDialogOpen(false);
    
//     if (!confirmDialogAction || !userToAction) return;
    
//     setLoading(true);
//     try {
//       if (confirmDialogAction === 'deactivate') {
//         await updateCandidate(fetchWithAuth, userToAction.id, { is_active: false });
//         setSuccess("Candidate deactivated");
//       } else if (confirmDialogAction === 'delete') {
//         await deleteCandidate(fetchWithAuth, userToAction.id);
//         setSuccess("Candidate permanently deleted");
//       }
//       setSnackbarOpen(true);
//       await loadData();
//     } catch (e) {
//       setError(e.message || `Failed to ${confirmDialogAction} candidate`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDeactivate = (user) => {
//     openConfirmDialog(
//       "Deactivate Candidate", 
//       `Are you sure you want to deactivate ${user.full_name || user.email}?`,
//       "deactivate",
//       user
//     );
//   };

//   const handleDelete = (user) => {
//     openConfirmDialog(
//       "Delete Candidate Permanently", 
//       `Are you sure you want to permanently delete ${user.full_name || user.email}? This will remove all their applications and cannot be undone.`,
//       "delete",
//       user
//     );
//   };
//   const handleResetPassword = (user) => { setResetUser(user); setResetModalOpen(true); };
//   const handleResetPasswordSave = async (password) => {
//     try {
//       setResetLoading(true);
//       await resetCandidatePassword(fetchWithAuth, resetUser.id, password);
//       setSuccess("Password reset successfully");
//       setSnackbarOpen(true);
//     } catch (e) {
//       setResetError(e.message || "Failed to reset password");
//     } finally {
//       setResetLoading(false);
//       setResetModalOpen(false);
//     }
//   };
//   const handleSave = async (form) => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       // Prepare data for API call
//       const candidateData = {
//         is_active: form.is_active,
//         is_applicant: form.is_applicant
//       };
      
//       // For new candidates, include required fields
//       if (!selectedUser) {
//         candidateData.email = form.email;
//         candidateData.full_name = form.full_name;
//         candidateData.password = form.password;
//       }
      
//       if (selectedUser) {
//         await updateCandidate(fetchWithAuth, selectedUser.id, candidateData);
//         setSuccess("Candidate updated successfully");
//       } else {
//         await createCandidate(fetchWithAuth, candidateData);
//         setSuccess("Candidate created successfully");
//       }
      
//       setSnackbarOpen(true);
//       setModalOpen(false);
//       await loadData();
//     } catch (e) {
//       setError(e.message || "Failed to save candidate");
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleChangePage = (event, newPage) => { setPage(newPage); };
//   const handleChangeRowsPerPage = (event) => { setRowsPerPage(parseInt(event.target.value, 10)); setPage(0); };
//   const paginatedUsers = users.filter(u => {
//     if (!search) return true;
//     return (
//       u.full_name?.toLowerCase().includes(search.toLowerCase()) ||
//       u.email?.toLowerCase().includes(search.toLowerCase())
//     );
//   }).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
//   return (
//     <Box sx={{ display: "flex", minHeight: "100vh", background: "#f7f7fa" }}>
//       <AdminSidebar selected="Candidates" />
//       <Box sx={{ flex: 1, p: 3, mt: 7, mb: 3 }}>
//         <Paper elevation={2} sx={{ p: 3 }}>
//           <Typography variant="h4" gutterBottom>
//             Candidates Management
//           </Typography>
//           {error && (
//             <Alert severity={error.includes("permission") ? "warning" : "error"} sx={{ mb: 2 }}>{error}</Alert>
//           )}
//           <Button variant="contained" sx={{ mb: 2 }} onClick={handleCreate} disabled={loading || (error && error.includes("permission"))}>
//             Create Candidate
//           </Button>
//           {loading ? (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
//               <CircularProgress size={40} />
//             </Box>
//           ) : (
//             <>
//               <CandidateTable
//                 onDeactivate={handleDeactivate}
//                 users={paginatedUsers}
//                 onEdit={handleEdit}
//                 onDelete={handleDelete}
//                 onResetPassword={handleResetPassword}
//                 loading={loading}
//                 search={search}
//                 setSearch={setSearch}
//                 onRowClick={user => setDetailsUser(user)}
//               />
//               <TablePagination
//                 component="div"
//                 count={users.length}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 rowsPerPage={rowsPerPage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//                 rowsPerPageOptions={[5, 10, 25, 50]}
//                 sx={{ mt: 2 }}
//               />
//             </>
//           )}
//           <CandidateModal
//             open={modalOpen}
//             onClose={() => setModalOpen(false)}
//             user={selectedUser}
//             roles={roles}
//             onSave={handleSave}
//             loading={loading}
//           />
//           <CandidateDetailsModal
//             open={!!detailsUser}
//             onClose={() => setDetailsUser(null)}
//             user={detailsUser}
//           />
//           <ResetPasswordModal
//             open={resetModalOpen}
//             onClose={() => setResetModalOpen(false)}
//             onSubmit={handleResetPasswordSave}
//             user={resetUser}
//             loading={resetLoading}
//             error={resetError}
//           />
          
//           <Dialog
//             open={confirmDialogOpen}
//             onClose={handleConfirmDialogClose}
//             aria-labelledby="alert-dialog-title"
//             aria-describedby="alert-dialog-description"
//           >
//             <DialogTitle id="alert-dialog-title">{confirmDialogTitle}</DialogTitle>
//             <DialogContent>
//               <DialogContentText id="alert-dialog-description">
//                 {confirmDialogMessage}
//               </DialogContentText>
//             </DialogContent>
//             <DialogActions>
//               <Button onClick={handleConfirmDialogClose} color="primary">
//                 Cancel
//               </Button>
//               <Button onClick={handleConfirmAction} color="error" variant="contained" autoFocus>
//                 Confirm
//               </Button>
//             </DialogActions>
//           </Dialog>
          
//           <Snackbar 
//             open={snackbarOpen} 
//             autoHideDuration={3000} 
//             onClose={() => setSnackbarOpen(false)}
//             anchorOrigin={{ vertical: "top", horizontal: "center" }}
//           >
//             <Alert severity="success" onClose={() => setSnackbarOpen(false)}>
//               {success}
//             </Alert>
//           </Snackbar>
//         </Paper>
//       </Box>
//     </Box>
//   );
// }

import React, { useEffect, useState } from "react";
import { hasAnyPermission } from "../utils/permissions";
import {
  Box,
  Container,
  Typography,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TablePagination,
  CircularProgress,
  Alert,
  TextField,
  Snackbar,
  IconButton,
  Tooltip,
  InputAdornment,
  Chip,
  Toolbar,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import AdminSidebar from "../AdminSidebar";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  fetchCandidates,
  createCandidate,
  updateCandidate,
  deleteCandidate,
  resetCandidatePassword,
  fetchRoles,
} from "../api";
import { useAuth } from "../App";
import Forbidden403 from "../components/common/Forbidden403";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import LockResetIcon from "@mui/icons-material/LockReset";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useSearchParams } from "react-router-dom";

function SectionEyebrow({ children, color }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 2,
          borderRadius: 2,
          bgcolor: "currentColor",
          flexShrink: 0,
        }}
      />
      {children}
    </Box>
  );
}

function ResetPasswordModal({ open, onClose, onSubmit, user, loading, error }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const text = dark ? "#e8f0fe" : "#0f0f1a";

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState("");

  useEffect(() => {
    setPassword("");
    setLocalError("");
  }, [open, user]);

  const handleSave = () => {
    if (!password || password.length < 8) {
      setLocalError("Password must be at least 8 characters");
      return;
    }
    onSubmit(password);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: 800,
          color: text,
          letterSpacing: "-0.02em",
        }}
      >
        Reset Password for {user?.email}
      </DialogTitle>

      <DialogContent dividers sx={{ minWidth: 320 }}>
        <TextField
          label="New Password"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          autoFocus
          margin="normal"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword((s) => !s)}
                  edge="end"
                  size="small"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          error={!!localError || !!error}
          helperText={localError || error}
          disabled={loading}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" disabled={loading || !password}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function CandidateDetailsModal({ open, onClose, user }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";

  if (!user) return null;

  const activeColor = user.is_active ? "success" : "default";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: 800,
          color: text,
          letterSpacing: "-0.02em",
        }}
      >
        Candidate Details
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box
          sx={{
            mb: 2,
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 800, color: text }}>
            {user.full_name}
          </Typography>
          <Typography component="span" variant="body2" color="text.secondary">
            ({user.email})
          </Typography>
          <Chip
            label={user.is_active ? "Active" : "Inactive"}
            color={activeColor}
            size="small"
            sx={{ ml: 1 }}
          />
        </Box>

        <Typography variant="body2" sx={{ color: mid, mb: 1 }}>
          <b style={{ color: text }}>Phone:</b> {user.phone || "-"}
        </Typography>
        <Typography variant="body2" sx={{ color: mid }}>
          <b style={{ color: text }}>Address:</b> {user.address || "-"}
        </Typography>
      </DialogContent>
    </Dialog>
  );
}

function CandidateTable({
  users,
  onEdit,
  onDelete,
  onDeactivate,
  onResetPassword,
  loading,
  search,
  setSearch,
  onRowClick,
}) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const accent = dark ? "#fb923c" : "#f97316";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  return (
    <Box>
      <TextField
        label="Search candidates"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        size="small"
        sx={{
          mb: 2,
          width: { xs: "100%", sm: 320 },
          "& .MuiOutlinedInput-root": {
            borderRadius: "14px",
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon sx={{ color: muted, fontSize: 18 }} />
            </InputAdornment>
          ),
        }}
      />

      <TableContainer
        sx={{
          borderRadius: "18px",
          border: `1px solid ${border}`,
          overflowX: "auto",
        }}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              {["Name", "Email", "Status", "Actions"].map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    fontWeight: 700,
                    color: mid,
                    background: dark ? "#111827" : "#fafafa",
                    borderBottom: `1px solid ${border}`,
                    whiteSpace: "nowrap",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {users.map((user) => (
              <TableRow
                key={user.id}
                hover
                onClick={() => onRowClick(user)}
                sx={{
                  cursor: "pointer",
                  "& td": {
                    borderBottom: `1px solid ${border}`,
                    background: dark ? "rgba(13,18,32,0.96)" : "#ffffff",
                    color: mid,
                  },
                  "&:hover td": {
                    background: dark
                      ? "rgba(255,255,255,0.03)"
                      : "rgba(15,15,26,0.02)",
                  },
                }}
              >
                <TableCell sx={{ color: text, fontWeight: 700 }}>
                  {user.full_name}
                </TableCell>

                <TableCell>{user.email}</TableCell>

                <TableCell>
                  <Chip
                    label={user.is_active ? "Active" : "Inactive"}
                    color={user.is_active ? "success" : "default"}
                    size="small"
                    sx={{ fontWeight: 700 }}
                  />
                </TableCell>

                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  <Tooltip title="Edit">
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        onEdit(user);
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  {user.is_active ? (
                    <Tooltip title="Deactivate">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          onDeactivate(user);
                        }}
                      >
                        <DeleteIcon fontSize="small" color="warning" />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Delete Permanently">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          onDelete(user);
                        }}
                      >
                        <DeleteIcon fontSize="small" color="error" />
                      </IconButton>
                    </Tooltip>
                  )}

                  <Tooltip title="Reset Password">
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        onResetPassword(user);
                      }}
                    >
                      <LockResetIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}

            {users.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography sx={{ py: 3, color: muted }}>
                    No candidates found.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

function CandidateModal({ open, onClose, user, roles, onSave, loading }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const text = dark ? "#e8f0fe" : "#0f0f1a";

  const [form, setForm] = useState(
    user || {
      email: "",
      full_name: "",
      is_active: true,
      is_applicant: true,
      role_ids: [],
      password: "",
      confirm_password: "",
    }
  );

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setForm(
      user || {
        email: "",
        full_name: "",
        is_active: true,
        is_applicant: true,
        role_ids: [],
        password: "",
        confirm_password: "",
      }
    );
    setErrors({});
  }, [user, open]);

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });

    if (errors[field]) {
      setErrors({ ...errors, [field]: null });
    }
  };

  const handleToggleActive = () => {
    setForm({ ...form, is_active: !form.is_active });
  };

  const handleToggleApplicant = () => {
    setForm({ ...form, is_applicant: !form.is_applicant });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!form.email) {
      newErrors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.email)) {
      newErrors.email = "Invalid email address";
    }

    if (!form.full_name) {
      newErrors.full_name = "Full name is required";
    }

    if (!user) {
      if (!form.password) {
        newErrors.password = "Password is required";
      } else if (form.password.length < 8) {
        newErrors.password = "Password must be at least 8 characters";
      }

      if (!form.confirm_password) {
        newErrors.confirm_password = "Confirm password is required";
      } else if (form.password !== form.confirm_password) {
        newErrors.confirm_password = "Passwords do not match";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (!validateForm()) return;

    const formData = { ...form };
    delete formData.confirm_password;

    onSave(formData);
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: 800,
          color: text,
          letterSpacing: "-0.02em",
        }}
      >
        {user ? "Edit Candidate" : "Create Candidate"}
      </DialogTitle>

      <DialogContent dividers>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            label="Full Name"
            value={form.full_name || ""}
            onChange={handleChange("full_name")}
            fullWidth
            margin="normal"
            required
            disabled={!!user}
            error={!!errors.full_name}
            helperText={errors.full_name}
            autoFocus
          />

          <TextField
            label="Email"
            value={form.email || ""}
            onChange={handleChange("email")}
            fullWidth
            margin="normal"
            disabled={!!user}
            required
            error={!!errors.email}
            helperText={errors.email}
            type="email"
          />

          {!user && (
            <>
              <TextField
                label="Password"
                value={form.password || ""}
                onChange={handleChange("password")}
                fullWidth
                margin="normal"
                required
                type={showPassword ? "text" : "password"}
                error={!!errors.password}
                helperText={errors.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={toggleShowPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                label="Confirm Password"
                value={form.confirm_password || ""}
                onChange={handleChange("confirm_password")}
                fullWidth
                margin="normal"
                required
                type={showPassword ? "text" : "password"}
                error={!!errors.confirm_password}
                helperText={errors.confirm_password}
              />
            </>
          )}

          <Box sx={{ mt: 3, display: "flex", alignItems: "center" }}>
            <Typography variant="body1" sx={{ mr: 2, color: text }}>
              Status:
            </Typography>
            <Chip
              label={form.is_active ? "Active" : "Inactive"}
              color={form.is_active ? "success" : "default"}
              onClick={handleToggleActive}
              sx={{ cursor: "pointer", fontWeight: 700 }}
            />
          </Box>

          <Box sx={{ mt: 2, display: "flex", alignItems: "center" }}>
            <Typography variant="body1" sx={{ mr: 2, color: text }}>
              Applicant:
            </Typography>
            <Chip
              label={form.is_applicant ? "Yes" : "No"}
              color={form.is_applicant ? "primary" : "default"}
              onClick={handleToggleApplicant}
              sx={{ cursor: "pointer", fontWeight: 700 }}
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={
            loading ||
            !form.email ||
            !form.full_name ||
            (!user && (!form.password || !form.confirm_password))
          }
        >
          {user ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default function Candidates() {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const pageBg = dark ? "#07080f" : "#ffffff";
  const panelBg = dark ? "#0d1220" : "#ffffff";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";

  const { auth, fetchWithAuth } = useAuth();
  const hasListPermission = hasAnyPermission(auth?.user, ["candidate.list", "user.list"]);

  if (!hasListPermission) {
    return (
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
        <AdminSidebar selected="Candidates" />
        <Box
          sx={{
            flex: 1,
            p: 3,
            mt: 7,
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Forbidden403 message="You are not authorized to perform this action. Please contact your system administrator." />
        </Box>
      </Box>
    );
  }

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [detailsUser, setDetailsUser] = useState(null);
  const [resetModalOpen, setResetModalOpen] = useState(false);
  const [resetUser, setResetUser] = useState(null);
  const [resetLoading, setResetLoading] = useState(false);
  const [resetError, setResetError] = useState(null);
  const [success, setSuccess] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [roles, setRoles] = useState([]);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [shouldAutoOpenCandidateModal, setShouldAutoOpenCandidateModal] = useState(false);

  useEffect(() => {
    loadData();
    fetchRoles(fetchWithAuth).then(setRoles).catch(() => {});
  }, []);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchCandidates(fetchWithAuth);
      setUsers(data);
    } catch (e) {
      setError(e.message || "Failed to load candidates");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const openParam = searchParams.get("open");
    if (openParam === "create") {
      setShouldAutoOpenCandidateModal(true);
      navigate("/admin/candidates", { replace: true });
    }
  }, [searchParams, navigate]);

  useEffect(() => {
    if (shouldAutoOpenCandidateModal) {
      handleCreate();
      setShouldAutoOpenCandidateModal(false);
    }
  }, [shouldAutoOpenCandidateModal]);

  const handleEdit = (user) => {
    setSelectedUser(user);
    setModalOpen(true);
  };

  const handleCreate = () => {
    setSelectedUser(null);
    setModalOpen(true);
  };

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState(null);
  const [userToAction, setUserToAction] = useState(null);
  const [confirmDialogTitle, setConfirmDialogTitle] = useState("");
  const [confirmDialogMessage, setConfirmDialogMessage] = useState("");

  const openConfirmDialog = (title, message, action, user) => {
    setConfirmDialogTitle(title);
    setConfirmDialogMessage(message);
    setConfirmDialogAction(action);
    setUserToAction(user);
    setConfirmDialogOpen(true);
  };

  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
  };

  const handleConfirmAction = async () => {
    setConfirmDialogOpen(false);

    if (!confirmDialogAction || !userToAction) return;

    setLoading(true);
    try {
      if (confirmDialogAction === "deactivate") {
        await updateCandidate(fetchWithAuth, userToAction.id, { is_active: false });
        setSuccess("Candidate deactivated");
      } else if (confirmDialogAction === "delete") {
        await deleteCandidate(fetchWithAuth, userToAction.id);
        setSuccess("Candidate permanently deleted");
      }
      setSnackbarOpen(true);
      await loadData();
    } catch (e) {
      setError(e.message || `Failed to ${confirmDialogAction} candidate`);
    } finally {
      setLoading(false);
    }
  };

  const handleDeactivate = (user) => {
    openConfirmDialog(
      "Deactivate Candidate",
      `Are you sure you want to deactivate ${user.full_name || user.email}?`,
      "deactivate",
      user
    );
  };

  const handleDelete = (user) => {
    openConfirmDialog(
      "Delete Candidate Permanently",
      `Are you sure you want to permanently delete ${user.full_name || user.email}? This will remove all their applications and cannot be undone.`,
      "delete",
      user
    );
  };

  const handleResetPassword = (user) => {
    setResetUser(user);
    setResetModalOpen(true);
  };

  const handleResetPasswordSave = async (password) => {
    try {
      setResetLoading(true);
      await resetCandidatePassword(fetchWithAuth, resetUser.id, password);
      setSuccess("Password reset successfully");
      setSnackbarOpen(true);
    } catch (e) {
      setResetError(e.message || "Failed to reset password");
    } finally {
      setResetLoading(false);
      setResetModalOpen(false);
    }
  };

  const handleSave = async (form) => {
    try {
      setLoading(true);
      setError(null);

      const candidateData = {
        is_active: form.is_active,
        is_applicant: form.is_applicant,
      };

      if (!selectedUser) {
        candidateData.email = form.email;
        candidateData.full_name = form.full_name;
        candidateData.password = form.password;
      }

      if (selectedUser) {
        await updateCandidate(fetchWithAuth, selectedUser.id, candidateData);
        setSuccess("Candidate updated successfully");
      } else {
        await createCandidate(fetchWithAuth, candidateData);
        setSuccess("Candidate created successfully");
      }

      setSnackbarOpen(true);
      setModalOpen(false);
      await loadData();
    } catch (e) {
      setError(e.message || "Failed to save candidate");
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedUsers = users
    .filter((u) => {
      if (!search) return true;
      return (
        u.full_name?.toLowerCase().includes(search.toLowerCase()) ||
        u.email?.toLowerCase().includes(search.toLowerCase())
      );
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
      <AdminSidebar selected="Candidates" />

      <Box
        sx={{
          flex: 1,
          pl: { xs: 1.5, md: 3 },
          pr: { xs: 1.5, md: 3 },
          pt: 2,
          pb: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />

        <Container maxWidth="xl" disableGutters sx={{ mt: 1 }}>
          <Box
            sx={{
              mb: 3,
              overflow: "hidden",
              borderRadius: "28px",
              border: `1px solid ${dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0"}`,
              background: dark
                ? `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(7,8,15,0.96) 45%, rgba(7,8,15,0.98) 100%)`
                : `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(255,255,255,0.98) 42%, rgba(248,248,251,0.98) 100%)`,
              boxShadow: dark
                ? "0 32px 80px rgba(0,0,0,0.30)"
                : "0 32px 80px rgba(15,15,26,0.08)",
            }}
          >
            <Box
              sx={{
                p: { xs: 3, sm: 4, md: 5 },
                display: "flex",
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              <Box>
                <SectionEyebrow color={accent}>AjiraHQ · Candidates</SectionEyebrow>
                <Typography
                  sx={{
                    mt: 2,
                    color: text,
                    fontWeight: 800,
                    fontSize: "clamp(30px, 4vw, 44px)",
                    lineHeight: 1.06,
                    letterSpacing: "-0.03em",
                    mb: 0.75,
                  }}
                >
                  Manage candidates.
                </Typography>
                <Typography
                  sx={{
                    color: mid,
                    fontSize: "15px",
                    lineHeight: 1.8,
                    maxWidth: 620,
                  }}
                >
                  View, create, edit, deactivate, and support candidate accounts.
                </Typography>
              </Box>

              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 700,
                  borderRadius: "12px",
                  px: 2.5,
                  py: 1.1,
                  background: accent,
                  boxShadow: `0 14px 34px ${alpha(accent, 0.22)}`,
                  "&:hover": {
                    background: accent,
                    filter: "brightness(1.08)",
                  },
                }}
                onClick={handleCreate}
                disabled={loading || (error && error.includes("permission"))}
              >
                Create Candidate
              </Button>
            </Box>
          </Box>

          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: "22px",
              background: panelBg,
              border: `1px solid ${dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0"}`,
              boxShadow: dark
                ? "0 20px 50px rgba(0,0,0,0.20)"
                : "0 12px 30px rgba(15,23,42,0.06)",
            }}
          >
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: "1.25rem",
                color: text,
                mb: 2,
                letterSpacing: "-0.02em",
              }}
            >
              Candidates Management
            </Typography>

            {error && (
              <Alert
                severity={error.includes("permission") ? "warning" : "error"}
                sx={{ mb: 2, borderRadius: "18px" }}
              >
                {error}
              </Alert>
            )}

            {loading ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight={200}
              >
                <CircularProgress size={40} sx={{ color: accent }} />
              </Box>
            ) : (
              <>
                <CandidateTable
                  onDeactivate={handleDeactivate}
                  users={paginatedUsers}
                  onEdit={handleEdit}
                  onDelete={handleDelete}
                  onResetPassword={handleResetPassword}
                  loading={loading}
                  search={search}
                  setSearch={setSearch}
                  onRowClick={(user) => setDetailsUser(user)}
                />

                <TablePagination
                  component="div"
                  count={users.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  sx={{ mt: 2, color: mid }}
                />
              </>
            )}

            <CandidateModal
              open={modalOpen}
              onClose={() => setModalOpen(false)}
              user={selectedUser}
              roles={roles}
              onSave={handleSave}
              loading={loading}
            />

            <CandidateDetailsModal
              open={!!detailsUser}
              onClose={() => setDetailsUser(null)}
              user={detailsUser}
            />

            <ResetPasswordModal
              open={resetModalOpen}
              onClose={() => setResetModalOpen(false)}
              onSubmit={handleResetPasswordSave}
              user={resetUser}
              loading={resetLoading}
              error={resetError}
            />

            <Dialog
              open={confirmDialogOpen}
              onClose={handleConfirmDialogClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle
                id="alert-dialog-title"
                sx={{
                  fontWeight: 800,
                  color: text,
                  letterSpacing: "-0.02em",
                }}
              >
                {confirmDialogTitle}
              </DialogTitle>

              <DialogContent dividers>
                <DialogContentText id="alert-dialog-description">
                  {confirmDialogMessage}
                </DialogContentText>
              </DialogContent>

              <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={handleConfirmDialogClose} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={handleConfirmAction}
                  color="error"
                  variant="contained"
                  autoFocus
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>

            <Snackbar
              open={snackbarOpen}
              autoHideDuration={3000}
              onClose={() => setSnackbarOpen(false)}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert severity="success" onClose={() => setSnackbarOpen(false)}>
                {success}
              </Alert>
            </Snackbar>
          </Paper>
        </Container>
      </Box>
    </Box>
  );
}